// Total possible two-card combinations in a 52-card deck:
//   13 pairs × 6 + 78 suited × 4 + 78 offsuit × 12 = 1326
export const TOTAL_POSSIBLE_COMBOS = 1326;

/**
 * Calculates the weighted combo count for a hand collection.
 * Uses the actions map (sum of all action frequencies) as the effective frequency.
 *
 * @param {Array} matrixCells - Array of hand objects with type and actions properties
 * @returns {number} - Total combos count (0–1326)
 */
export const calculateTotalCombos = (matrixCells) => {
  if (!matrixCells || !Array.isArray(matrixCells)) return 0;

  return matrixCells.reduce((total, cell) => {
    if (!cell.isActive) return total;

    // Sum all action frequencies to get effective play frequency (0–100).
    // Exclude 'inRange' — it's a display-only marker for hands in the range
    // file that don't match the current filter, not an actual action frequency.
    const actionFreq = Object.entries(cell.actions || {})
      .filter(([k]) => k !== 'inRange')
      .reduce((s, [, f]) => s + (f || 0), 0);
    const factor = Math.min(actionFreq / 100, 1);

    if (cell.type === 'pair')    return total + Math.round(6  * factor);
    if (cell.type === 'suited')  return total + Math.round(4  * factor);
    if (cell.type === 'offsuit') return total + Math.round(12 * factor);
    return total;
  }, 0);
};